import React, { useContext, useMemo } from 'react';
import { IEditModifierContext, EditModifierContext } from '../../../../editModifierState/editModifierContext';
import FormImageUploader from 'components/FormImageUploader/FormImageUploader';
import InputFields from './InputFields/InputFields';
import classNames from 'classnames';
import style from './EditForm.module.scss';

const descriptionOfAspectRatio = {
	horizontal: {
		ratio: '95:46',
		optimalResolutions: {
			a: '380*184px',
			b: '760*368px',
		},
	},
	vertical: {
		ratio: '44:19',
		optimalResolutions: {
			a: '528*228px',
			b: '1056*456px',
		},
	},
};

interface IProps {
	isVisible: boolean;
}

const EditForm: React.FC<IProps> = ({ isVisible }) => {
	const { deletePhoto, setFileId, fileId, filePath, preSignedUrl, modifierId } =
		useContext<IEditModifierContext>(EditModifierContext);

	const containerClasses = classNames(style.container, { [style.visible]: isVisible });

	const loadFromFilePathOptions = useMemo(
		() => ({
			filePath,
			preSignedUrl,
			entityID: modifierId,
		}),
		[filePath, preSignedUrl, modifierId],
	);

	return (
		<div className={containerClasses} data-test="EditForm">
			<FormImageUploader
				containerClass={style.imageUploader}
				maxFileSizeMB={1}
				fileId={fileId}
				loadFromFilePathOptions={loadFromFilePathOptions}
				deletePhotoHandler={deletePhoto}
				setFileId={setFileId}
				horizontalAspectRatio={380 / 184}
				verticalAspectRatio={528 / 228}
				descriptionOfAspectRatio={descriptionOfAspectRatio}
			/>
			<InputFields />
		</div>
	);
};

export default EditForm;
